import * as React from 'react';

/** Escuta uma media query (ex.: `(min-width: 1024px)`). Sem `matchMedia` (testes) devolve `padrao`. */
export function useMediaQuery(consulta: string, padrao = false): boolean {
  const [combina, setCombina] = React.useState(() =>
    typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(consulta).matches : padrao,
  );
  React.useEffect(() => {
    if (!window.matchMedia) return;
    const lista = window.matchMedia(consulta);
    const aoMudar = () => setCombina(lista.matches);
    aoMudar();
    lista.addEventListener?.('change', aoMudar);
    return () => lista.removeEventListener?.('change', aoMudar);
  }, [consulta]);
  return combina;
}
